import cookie from './cookie'
import { TOKEN_NAME } from './index'

// 获取token
export function getToken () {
  return cookie.get(TOKEN_NAME)
}

// 设置token
export function setToken (value) {
  return cookie.set(TOKEN_NAME, value)
}

// 删除token
export function removeToken (value) {
  cookie.remove(TOKEN_NAME)
}



// WEBPACK FOOTER //
// ./src/config/token.js